import { ExpenseType } from './ExpenseType';

export class ExpenseTypeConfiguration {
    Id: number;
    ExpenseTypeId: number;
    CustomName: string;
    Description: string;
    IsHidden: boolean;

    ExpenseType: ExpenseType;

    constructor(model?: ExpenseTypeConfiguration) {
        if (model) {
            this.Id = model.Id;
            this.ExpenseTypeId = model.ExpenseTypeId;
            this.CustomName = model.CustomName;
            this.Description = model.Description;
            this.IsHidden = model.IsHidden;
            this.ExpenseType = new ExpenseType(model.ExpenseType);
        } else {
            this.Id = null;
            this.ExpenseTypeId = null;
            this.CustomName = null;
            this.Description = null;
            this.IsHidden = null;
            this.ExpenseType = null;
        }
    }
}
